import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { BatchFormValues } from "src/models/Batch.model";
import BatchForm from "../Layouts/BatchForm";
import moment from "moment";
import { useAddBatchMutation } from "src/services/BatchServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddBatchFormWrapper = ({ onClose }: Props) => {
  const [addBatch] = useAddBatchMutation();

  // Form Initial Values
  const initialValues: BatchFormValues = {
    batchName: "",
    plan:"" ,
    course: "",
    weekOffs:[],
    mode: "",
    allBranches: false,
    branches: [],
    startDate: null,
    startTime: null,
    endTime: null,
    trainers: [],
    language: "",
    fees: "",
    seats: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchName: string().required("Please enter batch name"),
    course: object().required("Please select course"),
    plan :  object().required("Please select plan") ,
    mode: object().required("Please select mode"),
    startDate: string().required("Please select start date"),
    startTime: string().required("Please select start time"),
    endTime: string().required("Please select end time"),
    fees: string().required("Please enter fees"),
    seats: string().required("Please enter no of seats"),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchFormValues>
  ) => {
    const formattedValues = {
      allBranches: values.allBranches,
      planId:values?.plan?.value ,
      batchName: values?.batchName,
      weekOffs: values?.weekOffs?.map((el:any)=>el?.value),
      batchCourses: values?.course?.value,
      modeId: values?.mode?._id,
      branchId: values?.branches?.map((branch) => branch?.value),
      startDate: values?.startDate
        ? moment(values?.startDate).format("yyyy-MM-DD")
        : "",
      estimatedEndDate: "",
      time: `${
        values?.startTime ? moment(values?.startTime).format("hh:mm A") : "" 
      } ${
        values?.endTime ? `- ${moment(values?.endTime).format("hh:mm A")}` : ""
      } `,
      trainers: values?.trainers?.map((trainer) => trainer?.value),
      language: values?.language?._id,
      fees: values?.fees,
      noOfSeats: values?.seats,
    };

    addBatch(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xl' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BatchForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBatchFormWrapper;
